"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MERCURYO_ENDPOINTS = exports.MERCURYO_API_DEV = exports.MERCURYO_API_PROD = void 0;
exports.MERCURYO_API_PROD = "https://api.mercuryo.io/v1.6";
exports.MERCURYO_API_DEV = "https://sandbox-api.mrcr.io/v1.6";
exports.MERCURYO_ENDPOINTS = {
    RATES: "/public/rates",
    BUY_RATE: "/widget/buy/rate",
    CURRENCIES: "/lib/currencies",
    CURRENCIES_BUY: "/public/currencies-buy",
    CURRENCIES_SELL: "/public/currencies-sell",
    LIMITS: "/public/currency-limits?",
    COUNTRIES: "/public/card-countries",
};
//# sourceMappingURL=constants.js.map